<template>
  <div class="tab-container">
    <b-tabs type="is-boxed" size="is-small">
        <b-tab-item>
          <template slot="header" class="header">
              <span class="mdi mdi-account-circle mdi-24px" style="margin-left:5px;"></span>
              <span> 基本情報 </span>
          </template>
          <div class="flex block-container disp-scroll">
            <p style="padding: 10px;"></p>
            <div class="edit-field">
              <b-field label="Email" style="text-align: left;">
                <b-input v-model="user.email"
                         type="email"
                         icon="email"
                         class="buefy-input">
                </b-input>
              </b-field>
              <b-field label="名前" style="text-align: left;">
                <b-input v-model="user.username"
                         class="buefy-input"
                         icon="account"
                         maxlength="20">
                </b-input>
              </b-field>
              <b-field>
                <a id="PS-0001" class="button is-primary" @click="setProfile({'username': user.username, 'email': user.email}, 'user')">変更する</a>
              </b-field>
              <hr>
              <!-- パスワード変更日を横並びで表示 -->
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;"><strong>パスワード変更日：</strong></span>
                <span>{{ passwordSetDate | formatDate }}</span>
              </div>
              <b-field label="現在のパスワード" style="text-align: left;">
                <b-input v-model="oldPassword"
                         class="buefy-input-password"
                         type="password"
                         icon="lock"
                         minlength="8"
                         password-reveal>
                </b-input>
              </b-field>
              <b-field label="新しいパスワード" style="text-align: left;">
                <b-input v-model="newPassword"
                         class="buefy-input-password"
                         type="password"
                         icon="lock"
                         minlength="8"
                         maxlength="20"
                         password-reveal>
                </b-input>
              </b-field>
              <b-field>
                <a id="PS-0002" class="button is-primary" @click="setProfile({'password': newPassword, 'old_password': oldPassword}, 'user')">変更する</a>
              </b-field>
              <hr>
              <b-field id="PS-0003" style="text-align: left;" label="訪問者通知">
                <b-switch style="width: 60%;" size="is-small" v-model="user.isNoticeNewVisitor">
                  通知{{user.isNoticeNewVisitor ? 'あり' : 'なし'}}
                </b-switch>
              </b-field>
              <b-field>
                <a id="PS-0004" class="button is-primary" @click="setProfile({'isNoticeNewVisitor': user.isNoticeNewVisitor}, 'user')">変更する</a>
              </b-field>
              <template v-if="user.isAgent">
                <hr>
                <b-field label="重複ログイン許可" style="text-align: left;">
                  <b-switch style="width: 60%;" size="is-small" v-model="user.is_duplicate_login">
                    重複ログイン{{user.is_duplicate_login ? '許可' : '不可'}}
                  </b-switch>
                </b-field>
                <b-field>
                  <a id="PS-0008" class="button is-primary" @click="setProfile({'is_duplicate_login': user.is_duplicate_login}, 'user')">変更する</a>
                </b-field>
              </template>
              <hr>
              <b-field label="応募者管理画面の表示設定" style="text-align: left;">
                <div style="margin-bottom: 10px;">
                  <b-switch
                    v-model="user.show_all_applicants"
                    size="is-small"
                  >
                    応募者一覧ですべての応募者を表示する
                  </b-switch>
                  <p style="font-size: 12px; color: #666; margin-top: 5px;">
                    OFFにすると振り分け済みの応募者は表示されません
                  </p>
                </div>
              </b-field>
              <b-field>
                <a class="button is-primary" @click="setProfile({'show_all_applicants': user.show_all_applicants}, 'user')">変更する</a>
              </b-field>
              <template v-if="user.isAgent">
                <hr>
                <b-field label="バージョン（半角で「1」か「2」を選択）" style="text-align: left;">
                  <select class="select" v-model="user.version">
                    <option id="PS-0005" value="1">1</option>
                    <option id="PS-0006" value="2">2</option>
                  </select>
                </b-field>
                <b-field>
                  <a id="PS-0007" class="button is-primary" @click="setProfile({'version': Number(user.version)}, 'user')">変更する</a>
                </b-field>
              </template>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item>
            <template slot="header" class="header">
                <span class="mdi mdi-account-details mdi-24px" style="margin-left:5px;"></span>
                <span> プロフィール情報 </span>
            </template>
            <div class="flex block-container disp-scroll">
              <p style="padding: 10px;"></p>
              <div class="edit-field">
              <b-field style="text-align: left;" label="アイコン"></b-field>
              <b-modal :active.sync="isFileUp" @close="isFileUp=false">
                          <Cropper @imageMethod="imageMessage"></Cropper></b-modal>

              <b-field v-if="!isUploaded">
                <img v-show="profileImage" :src="profileImage"  style="margin-right: auto; max-width: 100px; max-height: 100px; border-radius:15px; border: solid thin #ccc;"/>
                <label class="file-label">
                  <!-- <input class="file-input" type="file" name="resume" v-on:change="onFileChange"> -->
                  <span class="file-cta" @click="isFileUp = true">
                    <span class="file-icon">
                      <i class="mdi mdi-upload"></i>
                    </span>
                    <span class="file-label">
                      {{ $t('Setting.file_upload') }}
                    </span>
                  </span>
                </label>
                <a class="button is-primary" disabled>Iconを変更する</a>
              </b-field>
              <b-field v-else>
                <img v-show="uploadedImage" :src="uploadedImage"  style="margin-right: auto; max-width: 100px; max-height: 100px; border-radius:15px; border: solid thin #ccc;"/>
                <label class="file-label">
                  <!-- <input class="file-input" type="file" name="resume" v-on:change="onFileChange"> -->
                  <span class="file-cta"  @click="isFileUp = true">
                    <span class="file-icon">
                      <i class="mdi mdi-upload"></i>
                    </span>
                    <span class="file-label">
                      {{ $t('Setting.file_upload') }}
                    </span>
                  </span>
                  <span class="file-name">
                    {{ filename }}
                  </span>
                </label>
                <a class="button is-primary" @click="setUserIcon(uploadedImage, 'set-icon')">Iconを変更する</a>
              </b-field>
              <b-field label="電話番号(SMS受信用)" style="text-align: left;">
                <b-input v-model="user.profileTel"
                         class="buefy-input"
                         maxlength="20"
                         >
                </b-input>
              </b-field>
              <b-field label="一言" style="text-align: left;">
                <b-input v-model="user.profileMessage"
                         class="buefy-input"
                         maxlength="20"
                         >
                </b-input>
              </b-field>
              <b-field label="自己紹介" style="text-align: left;">
                <b-input v-model="user.profileDesc"
                         type="textarea"
                         class="buefy-textarea"
                         maxlength="300"
                         >
                </b-input>
              </b-field>
              <b-field label="所属：仕事内容" style="text-align: left;">
                <b-input v-model="user.profileCareer"
                         class="buefy-textarea"
                         type="textarea"
                         maxlength="300"
                         >
                </b-input>
              </b-field>
              <b-field label="一日のスケジュール" style="text-align: left;">
                <b-input v-model="user.profileDschedule"
                         class="buefy-textarea"
                         type="textarea"
                         maxlength="300"
                         >
                </b-input>
              </b-field>
              <b-field label="興味のあること" style="text-align: left;">
                <b-input v-model="user.profileInterst"
                         class="buefy-textarea"
                         type="textarea"
                         maxlength="500"
                         >
                </b-input>
              </b-field>
              <b-field label="趣味・特技" style="text-align: left;">
                <b-input v-model="user.profileHobby"
                         class="buefy-textarea"
                         type="textarea"
                         maxlength="300"
                         >
                </b-input>
              </b-field>
              <b-field label="スキル" style="text-align: left;">
                <b-input v-model="user.profileSkill"
                         type="textarea"
                         class="buefy-textarea"
                         maxlength="300"
                         >
                </b-input>
              </b-field>
              <a id="PS-0008" class="button is-primary" @click="setProfile({'tel': user.profileTel, 'description': user.profileDesc, 'message': user.profileMessage, 'interest': user.profileInterst, 'hobby': user.profileHobby, 'career': user.profileCareer, 'skill': user.profileSkill, 'department_schedule': user.profileDschedule}, 'profile')">変更する</a>
            </div>
          </div>
        </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cropper from '@/views/DashBoard/ChatBot/Cropperjsicon'
import Push from 'push.js'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'PersonalSetting',
  componentName: 'PersonalSetting',
  components: {
    Cropper
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      COMPONENT_NAME: 'PersonalSetting',
      isUploaded: false,
      filename: 'loading',
      uploadedImage: '',
      file: null,
      oldPassword: '',
      newPassword: '',
      isFileUp: false,
      isDataLogout: false
    }
  },
  computed: {
    ...mapState('auth', ['user', 'error', 'success']),
    profileImage: function () {
      return this.user.profileIcon
    },
    profileFilename: function () {
      return this.user.profileIcon.slice(this.user.profileIcon.lastIndexOf('/') + 1, this.user.profileIcon.length)
    },
    passwordSetDate: function () {
    // users.userテーブルからpassword_set_dateを取得
    return this.user.password_set_date;
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      // 日付のフォーマットを変更する
      const date = new Date(value);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}年${month}月${day}日`;
    }
  },
  watch: {
    success: function () {
      if (this.success) {
        // Email、名前、パスワードを変えた時は強制ログアウトする
        if (this.isDataLogout) {
          alert('変更を反映するためログアウトします。\n再度ログイン操作を行ってください。')
          // 設定変更後にlogoutすると認証切れで401が返りログアウトできない
          // ここではローカルストレージのトークン情報をクリアすることで、
          // ブラウザのログイン状態を強制的にログアウト状態にしてログイン画面に遷移する
          document.location.href = '/login'
          this.$store.dispatch('auth/forceLogout')
        } else {
          this.$buefy.snackbar.open({
            message: 'セーブしました！',
            type: 'is-success',
            position: 'is-top'
          })
        }
      }
    },
    error: function () {
      if (this.error) {
        this.$buefy.snackbar.open({
          message: '正常に保存が完了しませんでした。再読み込みしてください。',
          type: 'is-danger',
          position: 'is-top'
        })
      }
    }
  },
  mounted() {
    // show_all_applicants のデフォルト値を設定
    if (this.user.show_all_applicants === undefined) {
      this.$set(this.user, 'show_all_applicants', true)
    }
  },
  methods: {
    setProfile (data, type) {
      this.sendControlLog('個人設定　変更', '個人設定画面にて、「変更する」ボタンをクリックした。')
      if (data.username || data.email || (data.password && data.old_password)) {
        // 変更後ログアウトが必要
        this.isDataLogout = true
      }
      // 訪問者通知の承認
      if (this.user.isNoticeNewVisitor) {
        if (Push.Permission.get() === Push.Permission.DENIED) {
          // 通知の拒否設定がされていた場合、メッセージを表示する
          alert('訪問者通知の設定\nHRモンスターからの通知が拒否されています。\nブラウザの設定から通知を許可してください。')
        } else if (Push.Permission.get() === Push.Permission.DEFAULT) {
          // 通知未承認の場合、設定変更時に承認要求を行う
          Push.Permission.request()
        }
      }
      if (this.uploadedImage) {
        // アイコンが変更されている場合は一緒に保存する
        this.setUserIcon(this.uploadedImage, 'set-profile')
      }
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
      this.oldPassword = ''
      this.newPassword = ''
    },
    setUserIcon (data, set) {
      this.$store.dispatch('auth/setUserIcon', {name: this.filename, data: data})
      if (set == 'set-icon') {
        this.$buefy.snackbar.open({
          message: 'セーブしました！',
          type: 'is-success',
          position: 'is-top'
        })
      }
      this.isUploaded = false
      this.filename = ''
      this.file = null
    },
    onFileChange (e) {
      this.isUploaded = true
      let files = e.target.files || e.dataTransfer.files
      this.createImage(files[0])
      this.filename = files[0].name
      this.file = files[0]
    },
    // アップロードした画像を表示
    createImage (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.uploadedImage = e.target.result
      }
      reader.readAsDataURL(file)
    },
    imageMessage(photo, img_name) {
      this.isUploaded = true
      this.uploadedImage = photo
      this.filename = img_name
    }
  }
}
</script>

<style scoped>
.tab-container {
  margin: 0;
  height: 100vh;
}
.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.block-container {
  height: calc(100vh - 50px);
  padding: 20px;
  width: 100%;
  flex-flow: column nowrap;
}

.edit-field{
  padding: 20px;
  background: #FEFEFE;
}
.label {
  width: 50px !important;
}
h1 {
  font-weight: 700;
  font-size: 1.0em;
}
.blank {
  width: 10vw;
}
.add-box {
  margin-top: 15px;
  width: 65vw;
  height: auto;
  padding: 20px;
  line-height: 13px;
  border: solid thin #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/PersonalSetting.vue